import qs from 'qs';
import api from './api';

interface SetFCMTokenPayload {
  token: string;
  userId?: number;
}

interface SaveNotificationPayload {
  userId: number;
  type: string;
  title: string;
  message: string;
  senderId?: number;
  channel?: string;
  bookingId?: number;
  referralId?: number;
}

interface MarkNotificationAsReadPayload {
  notificationId: number;
  userId: number;
}

const notificationServices = {
  setFCMToken(payload: SetFCMTokenPayload) {
    return api.post(
      '/push-notifications/register-token',
      JSON.stringify(payload),
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
  },

  
  saveNotification(payload: SaveNotificationPayload) {
    return api.post('/notifications/save', payload, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },

  getMyNotifications(userId: number) {
    const queryParams = {
      userId: userId,
    };
    const queryString = qs.stringify(queryParams);
    const endpoint = `/notifications?${queryString}`;
    return api.get(endpoint);
  },


  getNotificationsWithPagination(
    userId: number,
    page: number = 1,
    limit: number = 20,
    type?: string,
    isRead?: boolean
  ) {
    const queryParams: any = {
      userId,
      page,
      limit,
    };

    if (type) {
      queryParams.type = type;
    }

    if (isRead !== undefined) {
      queryParams.isRead = isRead;
    }

    const queryString = qs.stringify(queryParams);
    const endpoint = `/notifications?${queryString}`;
    return api.get(endpoint);
  },


  markNotificationAsRead(notificationId: number, userId: number) {
    return api.put(
      '/notifications/mark-read',
      {
        notificationId,
        userId,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
  },

  
  markMultipleNotificationsAsRead(
    notificationIds: number[],
    userId: number
  ) {
    return api.put(
      '/notifications/mark-read-multiple',
      {
        notificationIds,
        userId,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
  },

  markAllNotificationsAsRead(userId: number) {
    return api.put(
      '/notifications/mark-all-read',
      { userId },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
  },


  deleteNotification(notificationId: number) {
    return api.delete(`/notifications/${notificationId}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },

 
  deleteMultipleNotifications(notificationIds: number[]) {
    return api.delete('/notifications/delete-multiple', {
      data: { notificationIds },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },

 
  getUnreadCount(userId: number) {
    const queryParams = { userId };
    const queryString = qs.stringify(queryParams);
    const endpoint = `/notifications/unread-count?${queryString}`;
    return api.get(endpoint);
  },

  clearAllNotifications(userId: number) {
    return api.delete('/notifications/clear-all', {
      data: { userId },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },

  getNotificationPreferences(userId: number) {
    return api.get(`/notifications/preferences/${userId}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  },


  updateNotificationPreferences(userId: number, preferences: any) {
    return api.put(
      `/notifications/preferences/${userId}`,
      preferences,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
  },
};

export default notificationServices;